import React, { useState } from "react";
import './Accounts.css';
import styles from '../../views/ManagementPages.module.css';
import { setNestedField } from './RegistrationSlice';
import { useSelector, useDispatch } from 'react-redux';
import { Form, FloatingLabel } from "react-bootstrap";
import { normalizeHeightToCm, buildHeightState, buildWeightState } from '../../utils/accountUtils';


const HealthInfo = () => {
    const dispatch = useDispatch();
    const dropdowns = useSelector((state) => state.dropdowns);
    const userData = useSelector((state) => state.registration);
    const isMetric = userData.preferences.unitType === "Metric";
    const birthday = userData.healthInfo.dateOfBirth ? userData.healthInfo.dateOfBirth.substring(0, 10) : "";

    const handleChange = (e) => {
        const { id, value } = e.target;
        dispatch(setNestedField({ parentKey: "healthInfo", nestedKey: id, value: value }));
    };
    
    //weight 
    const [weight, setWeight] = useState(() =>
        buildWeightState(isMetric, userData.healthInfo.weight)
    );

     // height 
    const [height, setHeight] = useState(() =>
        buildHeightState(isMetric, userData.healthInfo.height)
    );

    const handleWeightBlur = () => {
        if (weight ==='' || /^\d+$/.test(weight)) {
            if (weight==='' || weight=== 0) {
                dispatch(setNestedField({ parentKey: "healthInfo", nestedKey: "weight", value: '' }));
                return;
            }else {
                const numericValue = Number(weight);
                let metricValue = numericValue;
                if (!isMetric) {
                    // convert lb to kg
                    metricValue = Number((metricValue * 0.45359237).toFixed(2));
                }
                dispatch(setNestedField({ parentKey: "healthInfo", nestedKey: "weight", value: metricValue }));
            }
        }
    };

    const handleHeightBlur = () => {
        const metricHeight = normalizeHeightToCm(isMetric, height);
        if (metricHeight === null) {
            return;
        }
        dispatch(
            setNestedField({
                parentKey: "healthInfo",
                nestedKey: "height",
                value: metricHeight,
            })
        );
    };

   
    const handleNotes = (e) => {
        handleChange(e);
    };
    return (
        <div className="create-account-inputs">
            <div className="input-name"
                style={{ paddingTop: "10px" }}>
                Date of Birth
            </div>
            <Form.Group controlId="dateOfBirth">
                <FloatingLabel label="Date of Birth*">
                    <Form.Control
                        value={birthday}
                        id="dateOfBirth"
                        className={`${styles.BorderedComponent}`}
                        onChange={handleChange}
                        placeholder="Date of Birth*"
                        style={{ width: "300px" }}
                        required
                        type="date"
                        min={new Date(new Date().setFullYear(new Date().getFullYear() - 200)).toISOString().split("T")[0]}
                        max={new Date().toISOString().split("T")[0]}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide your date of birth.
                    </Form.Control.Feedback>
                </FloatingLabel>

            </Form.Group>
            <div className="input-name"
                style={{ paddingTop: "10px" }}>
                Height
            </div>
            {isMetric ?
                <Form.Group controlId="cm">
                    <FloatingLabel label="cm">
                        <Form.Control
                           id="cm"
                           type="number"
                           min="1"
                           step="any"
                           placeholder={"cm"}
                           className={`${styles.BorderedComponent}`}
                           value={height.cm}
                            onChange={(e) => setHeight(prevUserData => ({
                                ...prevUserData,
                                "cm": e.target.value
                            }))}
                            style={{width:"300px"}}
                            onBlur={() => handleHeightBlur()}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please enter a positive number.
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
                
                :
                <div style={{ display: "flex", width: "300px", justifyContent: "space-between", marginBottom: "0" }}>
                    <Form.Group controlId="feet">
                        <FloatingLabel label="ft">
                            <Form.Control
                                className={`${styles.BorderedComponent}`}
                                style={{ width: "147px" }}
                                id="feet"
                                min="0"
                                max="8"
                                type="number"
                                placeholder={"ft"}
                                value={height.feet}
                                onChange={(e) => setHeight(prevUserData => ({
                                    ...prevUserData,
                                    "feet": e.target.value
                                }))}
                                onBlur={() => handleHeightBlur()}
                            />
                            <Form.Control.Feedback style={{ width: "145px" }} type="invalid">
                                Please enter a valid integer from 0-7
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group controlId="inches">
                        <FloatingLabel label="in">
                            <Form.Control
                                className={`${styles.BorderedComponent}`}
                                id="inches"
                                style={{ width: "147px" }}
                                type="number"
                                min="0"
                                max="11"
                                placeholder={"in"}
                                value={height.inches}
                                onChange={(e) => setHeight(prevUserData => ({
                                    ...prevUserData,
                                    "inches": e.target.value
                                }))}
                                onBlur={() => handleHeightBlur()}
                            />
                            <Form.Control.Feedback style={{ width: "145px" }} type="invalid">
                                Please enter a valid integer from 0-11
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </div>
            }
            <div className="input-name">
                Weight
            </div>
            <Form.Group controlId="weight">
                <FloatingLabel label={isMetric ? "kg" : "lb"}>
                    <Form.Control
                        className={`${styles.BorderedComponent}`}
                        style={{width:"300px"}}
                        type="number"
                        step="any"
                        id="weight"
                        min="1"
                        placeholder={isMetric ? "kg" : "lb"}
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        onBlur={() => handleWeightBlur()}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please enter a positive number.
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="Gender">
                <FloatingLabel label="Gender*">
                    <Form.Select
                        required
                        type="select"
                        value={userData.healthInfo.gender}
                        className={`${styles.BorderedComponent}`}
                        id="gender"
                        onChange={handleChange}
                        placeholder="Gender*"
                        style={{ width: "300px" }}
                    >
                        <option value="">Select a Gender</option>
                        {dropdowns.gender.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                        Please select a gender.
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="Ethnicity">
                <FloatingLabel label="Ethnicity*">
                    <Form.Select
                        required
                        type="select"
                        value={userData.healthInfo.ethnicity}
                        className={`${styles.BorderedComponent}`}
                        id="ethnicity"
                        onChange={handleChange}
                        placeholder="Ethnicity*"
                        style={{ width: "300px" }}
                    >
                        <option value="">Select Ethnicity</option>
                        {dropdowns.ethnicity.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                        Please select an ethnicity.
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="condition">
                <FloatingLabel label="Condition">
                    <Form.Control
                        id="conditions"
                        value={userData.healthInfo.conditions}
                        onChange={handleChange}
                        style={{ width: "300px" }}
                        className={`${styles.BorderedComponent}`}
                        placeholder="Condition"
                        type="text"
                    />
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="criticalLevel">
                <FloatingLabel label="Critical Level">
                    <Form.Select
                        type="select"
                        value={userData.healthInfo.criticalLevel}
                        className={`${styles.BorderedComponent}`}
                        id="criticalLevel"
                        onChange={handleChange}
                        placeholder="Critical Level"
                        style={{ width: "300px" }}
                    >
                        <option value="">Select Critical Level</option>
                        {dropdowns.criticalLevel.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
            </Form.Group>

            <Form.Group controlId="hase">
                <FloatingLabel label="Phase">
                    <Form.Select
                        type="select"
                        value={userData.healthInfo.phase}
                        className={`${styles.BorderedComponent}`}
                        id="phase"
                        onChange={handleChange}
                        placeholder="Phase"
                        style={{ width: "300px" }}
                    >
                        <option value="">Select Phase</option>
                        {dropdowns.phases.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
            </Form.Group>

            <Form.Group controlId="notes">
                <FloatingLabel label="Notes">
                    <Form.Control
                        value={userData.healthInfo.notes}
                        id="notes"
                        as="textarea"
                        rows={2}
                        className={`${styles.BorderedComponentTextArea}`}
                        onChange={e => handleNotes(e)}
                        placeholder="Notes"
                        style={{ width: "300px" }}
                    />
                </FloatingLabel>

            </Form.Group>
        </div>
    );
};

export default HealthInfo;

